import React from "react";
import Post from "./Post2";
import Comments from "../Comment/Comments";
import RightPanel from "../RightPanel/RightPanel";
import LeftPanel from "../LeftPanel/LeftPanel";
import SearchView from "../Search/SearchView";
import { useEffect, useState } from "react";
import GoogleAd from "../Adsense/GoogleAd";
import useViewport from "../Utils/useViewPort"
import MobilePost from "./MobilePost";
import MobileSearchList from "../Search/MobileSearchList";

class SearchContent extends React.Component {

    constructor(props) {
      super(props);
      this.state = { keySearch: null, search_list: [], searchActive: false, resultShow: false };
    }
  
    componentDidMount() {
  
      const keyS = localStorage.getItem("keySearch");
      const list = JSON.parse(localStorage.getItem("search_list"));
  
      if (keyS && list) {
        console.log(list)
        this.setState({ keySearch: keyS });
        this.setState({ search_list: list});
        this.setState({ resultShow: true })
        if (list.length > 0) {
          this.setState({ searchActive: true })
        }
      } else{
        this.setState({searchActive: false})
        this.setState({resultShow: false})
      }
      console.log("search vewi moved");

      if (list == null) {
        this.setState({ searchActive: true })
      }
    }
  
  
    componentWillUnmount() {
      localStorage.removeItem("keySearch");
      localStorage.removeItem("search_list");
      this.setState({searchActive: false})
      this.setState({resultShow: false})
      console.log("unmounted")
    }
  
  
    render() {
      const { keySearch, search_list } = this.state;
      return (
        <>
          <div className="search-mobile-view">
           <h3>Keyword: {keySearch}</h3>
            {this.state.resultShow && (<>
              {this.state.searchActive && (
                <>
                  < MobileSearchList slist={search_list} />
                </>
              )}
              {!this.state.searchActive && (<><h3>NO result</h3></>)}
            </>
            )}
          </div>
        </>
      );
    }
  }
  
  export default SearchContent;
  

// export const SearchContent = (props) => {
//   // const isMobile = useMediaQuery({ query: "(max-width: 760px)" });
//   // const isDesktopOrLaptop = useMediaQuery({
//   //   query: '(min-width: 1224px)'
//   //   })
//   //   const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
//   //   const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
//   //   const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
//   //   const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
//   const viewPort = useViewport();
//   const isMobile = viewPort.width <= 1024;
//   const post = props.post;
//   const content = props.content;
//   const slug = props.slug;
//   const [user, setUser] = useState();
//   const [leftDisp, setLeftDisp] = useState("block");
//   const [rightDisp, setRightDisp] = useState("block");
//   const [leftVis, setLeftVis] = useState("hidden");
//   const [rightVis, setRightVis] = useState("hidden");
//   // const [pload, setPload] = useState(false);


//   useEffect(() => {
//     var tmp = localStorage.getItem("user", null);
//     if (tmp !== "undefined" && tmp != null) {
//       setUser(JSON.parse(tmp).username);
//     }

   

//   }, []);



//   return (
//     <>
//       {/* {!isMobile &&<LeftPanel changeVis={setLeftLoaded} slug={props.slug} />} */}
//       <div
//         style={{
//           gridArea: "MainContent",
//           gridColumn: "6/30",
//           paddingLeft: isMobile ? "10px" : 0,
//           paddingRight: isMobile ? "10px" : 0,
//           marginRight: isMobile ? "10px" : "30px",
//           maxWidth:"100%",
//           width:"100%",
//         }}
//       >
//         <SearchView />
//         {isMobile &&  <GoogleAd
//           classNames="GoogAd"
//           slot="1622775764"
//           googleAdId="ca-pub-3156532081104759"
//         />}
//       </div>
//       {/* {!isMobile && <RightPanel changeVis = {setRightLoaded}/>} */}
//     </>
//   );
// };
